import axios from "./../../../../redux/my-axios";

export const LOGIN_URL = "/login";
export const LOGOUT_URL = "/logout";
export const ME_URL = "/user-profile";

// coming soon
export const REGISTER_URL = "/register";
export const REQUEST_PASSWORD_URL = "/forgot-password";
export const RESET_PASSWORD_URL = "/reset-password";

// functions
export function login(email, password, captcha) {
  return axios.post(LOGIN_URL, { email, password, captcha });
}

export function logout() {
  return axios.post(LOGOUT_URL, {});
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

// coming soon
export function register(email, fullName, mobileNo, password) {
  return axios.post(REGISTER_URL, { email, fullName, mobileNo, password });
}

export function resetPassword(currentPassword, newPassword) {
  return axios.post(RESET_PASSWORD_URL, { currentPassword, newPassword });
}

export function requestPassword(email, captcha) {
  return axios.post(REQUEST_PASSWORD_URL, { email, password: captcha });
}
